import authAxios, { authHeader } from "./data";
import qs from "qs";

const fetchMessages = async (request: any, id: string) => {
  const response = await authAxios.get(
    `/api/Accesses/Conversations/${id}/Messages`,
    {
      params: request,
      paramsSerializer: (params) => {
        return qs.stringify(params);
      },
      headers: authHeader(),
    },
  );

  return response.data;
};

const fetchUnreads = async (id: string) => {
  const response = await authAxios.get(
    `/api/Accesses/Conversations/${id}/messages/unreads`,
    {
      headers: authHeader(),
    },
  );

  return response.data;
};

const fetchConversations = async () => {
  const response = await authAxios.get("/api/Accesses/Conversations", {
    headers: authHeader(),
  });

  return response.data;
};

const initialize = async (request: any) => {
  const response = await authAxios.get(
    "/api/Accesses/Conversations/Initialize",
    {
      params: request,
      paramsSerializer: (params) => {
        return qs.stringify(params);
      },
      headers: authHeader(),
    },
  );

  return response.data;
};

const send = async (req: any, conversationId: string) => {
  const result = await authAxios.post(
    `/api/Accesses/Conversations/${conversationId}/Send`,
    req,
    {
      headers: authHeader(),
    },
  );

  return result.data;
};

const download = async (req: any) => {
  const response = await authAxios.get(
    `/api/Accesses/Conversations/${req.conversationId}/attachments/${req.attachmentId}/download`,
    {
      paramsSerializer: (params) => {
        return qs.stringify(params);
      },
      headers: authHeader(),
      responseType: "blob",
    },
  );

  return response.data;
};

const read = async (id: string) => {
  const result = await authAxios.post(
    `/api/Accesses/Conversations/${id}/read`,
    null,
    {
      headers: authHeader(),
    },
  );

  return result.data;
};

const reportAbuse = async (id: string, req: any) => {
  const result = await authAxios.post(
    `/api/Accesses/Conversations/${id}/abuse`,
    req,
    {
      headers: authHeader(),
    },
  );

  return result.data;
};

export const MessagesService = {
  fetchMessages,
  fetchConversations,
  initialize,
  send,
  download,
  fetchUnreads,
  read,
  reportAbuse,
};
